module.exports = __webpack_public_path__ + "img/usimg.0e629af.png";